import { Flex, Text, useColorMode } from "@chakra-ui/react";
import numeral from "numeral";
import { getChakraColorAsHex } from "../../constants/colors";

export interface MetricTooltipValue {
  label: string;
  value: number;
  valueColor?: string;
  format?: string;
  suffix?: string;
}

const MetricsToolTip = ({
  title,
  metrics
}: {
  title?: string;
  metrics: MetricTooltipValue[];
}) => {
  const colorMode = useColorMode();
  return (
    <Flex direction={"column"}>
      <Text fontSize={"1em"} pb={"0.5em"}>
        {title}
      </Text>
      <Flex
        borderTop={"1px"}
        borderColor={"gray.300"}
        marginTop={"5px"}
        paddingTop={"5px"}
        display={"flex"}
        flexDirection={"column"}
        gap={1.5}
      >
        {metrics.map(({ label, value, format, suffix, valueColor }) => (
          <Flex key={label}>
            <Flex
              justify={"space-between"}
              grow={1}
              color={valueColor}
              textShadow={
                colorMode.colorMode === "dark"
                  ? `2px 2px 2px ${getChakraColorAsHex("gray.800")}`
                  : undefined
              }
            >
              <Text fontWeight={500} fontSize={"s"}>
                {label}:
              </Text>
              <Text
                justifyContent={"flex-end"}
                fontWeight={400}
                fontSize={"s"}
              >{` ${numeral(value).format(format ?? "0,0")}${
                suffix ?? ""
              }`}</Text>
            </Flex>
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
};

export default MetricsToolTip;
